import { useWorkingContext } from '@/hooks/useWorkingContext';

const SELECT =
  'border border-line bg-bg px-2 py-1 text-[12.5px] text-ink ' +
  'transition-colors hover:border-line-strong focus:border-accent focus:outline-none';

/**
 * The campus and academic year every list on the page reads from.
 *
 * It lives in the shell and appears exactly once, which is the point: when each
 * screen carried its own selectors, two pages could disagree about which year
 * you were looking at and nothing on either would say so.
 */
export function ContextBar() {
  const { campusId, academicYearId, setCampusId, setAcademicYearId, campuses, academicYears } =
    useWorkingContext();

  return (
    <div className="flex flex-wrap items-center gap-2.5 border-t border-line bg-surface px-4 py-2 lg:px-[30px]">
      <span className="text-[10px] uppercase tracking-[0.11em] text-muted">Working context</span>

      <select
        aria-label="Campus"
        className={SELECT}
        value={campusId ?? ''}
        onChange={(event) => setCampusId(event.target.value === '' ? null : event.target.value)}
      >
        <option value="">All campuses</option>
        {campuses.map((campus) => (
          <option key={campus.id} value={campus.id}>
            {campus.name}
          </option>
        ))}
      </select>

      <select
        aria-label="Academic year"
        className={SELECT}
        value={academicYearId ?? ''}
        onChange={(event) =>
          setAcademicYearId(event.target.value === '' ? null : event.target.value)
        }
      >
        {academicYears.map((year) => (
          <option key={year.id} value={year.id}>
            {year.name}
            {year.current ? ' (current)' : ''}
          </option>
        ))}
      </select>

      <span className="hidden text-xs text-muted md:inline">
        Every list, dashboard and register on this page reads from this context.
      </span>
    </div>
  );
}
